/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function StarHalf(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M128,189.44781a8.23108,8.23108,0,0,0-4.411,1.28485L76.71923,220.42741c-7.73631,4.90141-17.34149-2.38839-15.04583-11.41895l13.51384-53.16015a8.75742,8.75742,0,0,0-2.83756-8.87589L27.12238,109.329C21.1797,104.38277,24.247,94.52021,31.882,94.02469l59.06388-3.83326a8.41836,8.41836,0,0,0,7.24792-5.3506l22.02834-55.473A8.27507,8.27507,0,0,1,128.00007,24L128,24Z"
        opacity={0.2}
      />
      <Line
        x1={128}
        y1={24.00002}
        x2={128}
        y2={189.44779}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default StarHalf;
